module.exports = {
    // API_URl: `${process.env.REACT_APP_API_URL}`,
    API_URl: `http://localhost:4000/api/loan`
  };